<template>
  <div class="sub_content col-12 mt-2">
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <b-form @submit.prevent="passes(onSubmit);" @reset="resetForm">
        <div class="row">
          <DataListWithValidation
            rules="required"
            type="text"
            label="회사명"
            name="form.company1.name"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.company1.name"
            :options="companyOption1"
            @dataChanged="mCompanyChanged"
            description=""
            placeholder="회사를 입력해주세요."
          />

          <SelectWithValidation
            rules="required"
            type="text"
            label="지점명"
            name="form.company2.name"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.company2.seq"
            :options="companyOption2"
            @dataChanged="sCompanyChanged"
            description=""
            placeholder="지점를 입력해주세요."
          />
        </div>

        <div class="row">
          <InputWithValidation
            rules="required|min:6"
            type="text"
            label="차량번호"
            title="차량번호"
            name="form.num"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.num"
            description=""
            placeholder="차량번호를 입력해주세요."
          />
          <InputWithValidation
            rules=""
            type="text"
            label="차대번호(VIN)"
            title="차대번호(VIN)"
            name="form.vin"
            size="sm"
            class="col-6 d-inline-block"
            v-model="form.vin"
            description=""
            placeholder="차량번호를 입력해주세요."
          />

        </div>

        <div class="row">
          <InputWithValidation
            rules="required|min:6"
            type="text"
            label="차량명(임의)"
            title="차량명(임의)"
            name="form.custom"
            size="sm"
            class="col-2 d-inline-block"
            v-model="form.custom"
            description=""
            placeholder="차량명을 입력해주세요."
          />
          <SelectWithValidation
            rules=""
            label="제조사"
            name="form.brand"
            size="sm"
            class="col-2 d-inline-block"
            v-model="form.brand"
            :options="brandOption"
            @dataChanged="brandChanged"
            description=""
          />
          <SelectWithValidation
            rules=""
            label="모델명"
            name="form.model"
            size="sm"
            class="col-2 d-inline-block"
            v-model="form.model"
            :options="modelOption"
            @dataChanged="modelChanged"
            description=""
          />
          <SelectWithValidation
            rules=""
            label="세부모델명"
            name="form.smodel"
            size="sm"
            class="col-2 d-inline-block"
            v-model="form.smodel"
            :options="sModelOption"
            description=""
          />
          <SelectWithValidation
            rules=""
            label="등급"
            name="form.grade"
            size="sm"
            class="col-2 d-inline-block"
            v-model="form.grade"
            :options="gradeOption"
            description=""
          />
          <SelectWithValidation
            rules=""
            label="세부등급"
            name="form.sgrade"
            size="sm"
            class="col-2 d-inline-block"
            v-model="form.sgrade"
            :options="sGradeOption"
            description=""
          />
        </div>
        <div class="row">
          <InputWithValidation
            rules="required|min:4|max:4|integer"
            type="number"
            label="연식"
            title="차량 연식"
            name="form.custom"
            size="sm"
            class="col-2 d-inline-block"
            v-model="form.year"
            description=""
            placeholder="차량의 연식을 입력해주세요.ex)2004"
            autocomplete="off"
          />
          <SelectWithValidation
            rules="required"
            label="연료"
            name="form.fuel"
            size="sm"
            class="col-2 d-inline-block"
            v-model="form.fuel"
            :options="fuelOption"
            @dataChanged="fuelChanged"
            description=""
          />
          <InputWithValidation
            rules="required|integer"
            type="number"
            label="초기 주행거리"
            title="초기 주행거리"
            name="form.km"
            size="sm"
            class="col-2 d-inline-block"
            v-model="form.km"
            description=""
            placeholder="차량의 초기주행거리를 입력해주세요."
          />
          <div class="col-2 d-inline-block">
            <label class="col-form-label pt-0">초기검사일</label>
            <date-picker v-model="form.ins" @input="insChanged"></date-picker>
          </div>
          <InputWithValidation
            rules=""
            type="text"
            label="비고"
            title="비고"
            name="form.memo"
            size="sm"
            class="col-2 d-inline-block"
            v-model="form.memo"
            description=""
            placeholder="간단한 메모를 입력해주세요."
          />
        </div>
        <hr/>
        <div class="row">
          <InputWithValidation
            rules=""
            type="text"
            label="보험회사"
            title="보험회사"
            name="form.ins_company"
            size="sm"
            class="col-2 d-inline-block"
            v-model="form.ins_company"
            description=""
            placeholder="보험 회사를 입력해주세요."
          />
          <div class="col-2 d-inline-block">
            <label class="col-form-label pt-0">보험시작일</label>
            <date-picker v-model="form.ins_sdate" @input="insSdateChanged"></date-picker>
          </div>
          <div class="col-2 d-inline-block">
            <label class="col-form-label pt-0">보험마감일</label>
            <date-picker v-model="form.ins_edate" @input="insEdateChanged"></date-picker>
          </div>
        </div>
        <hr/>
        <div class="float-right">
          <b-button type="reset" size="sm" variant="danger" class="mr-2">다시쓰기</b-button>
          <b-button type="submit" size="sm" variant="primary" class="mr-2">저장</b-button>
          <b-button type="button" size="sm" variant="dark" @click="cancel">취소</b-button>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
import _ from 'lodash'
import { ValidationObserver } from 'vee-validate'
import InputWithValidation from '@/components/common/validations/inputbox'
import DataListWithValidation from '@/components/common/validations/datalist'
import SelectWithValidation from '@/components/common/validations/selectbox'
import datePicker from '@/components/common/datepicker/Picker'
import { phoneNumber } from '@/mixin/phoneNumber'
import ax from '@/api/car'
import { mCompanys, sCompanys } from '@/api/company'
import { carfuel } from '@/config/car'

export default {
  name: 'CarView',
  components: {
    ValidationObserver,
    InputWithValidation,
    DataListWithValidation,
    SelectWithValidation,
    datePicker
  },
  mixins: [phoneNumber],
  data () {
    return {
      companyOption1: [
        { value: '', text: '선택' },
      ],
      companyOption2: [
        { value: '', text: '선택' }
      ],
      brandOption: [
        { value: '', text: '선택' },
        { value: '현대', text: '현대' },
        { value: '기아', text: '기아' },
        { value: '르노삼성', text: '르노삼성' },
      ],
      modelOption: [
        { value: '', text: '선택' },
        { value: '코나', text: '코나' },
        { value: '니로', text: '니로' },
        { value: '아이오닉', text: '아이오닉' },
        { value: 'SM3', text: 'SM3' },
        { value: '니로플러스', text: '니로플러스' },
        { value: '아이오닉5', text: '아이오닉5' },
        { value: 'EV6', text: 'EV6' },
        { value: '포터2EV', text: '포터2EV' },
        { value: '봉고3EV', text: '봉고3EV' },
      ],
      sModelOption: [
        { value: '', text: '선택' }
      ],
      gradeOption: [
        { value: '', text: '선택' }
      ],
      sGradeOption: [
        { value: '', text: '선택' }
      ],
      fuelOption: carfuel.map(v => {return v === '' ? { value: '', text: '선택' } : { value: v, text: v }}),
      
      form_: {
        csseq: null,
        num: '',
        custom: '',
        brand: '',
        model: '',
        smodel: '',
        grade: '',
        sgrade: '',
        vin: 'VIN-num',
        year: '2023',
        fuel: '전기',
        km: '0',
        ins: this.$moment().format('YYYY-MM-DD'),
        ins_company: '',
        ins_sdate: this.$moment().format('YYYY-MM-DD'),
        ins_edate: this.$moment().format('YYYY-MM-DD'),
        memo: '',
        company1: { seq: null, name: '', sname: '' },
        company2: { seq: null, name: '', sname: '' }
      },

      form: {}
    }
  },
  watch: {},

  created () {
    this.form = _.cloneDeep(this.form_)
    // console.log("created", this.form);

  },

  mounted () {
    mCompanys(response => {
      this.companyOption1 = response
    })
    if (this.$route.params.seq) {
      ax.get(this.$route.params.seq, response => {
        this.form = response

        // console.log("mounted", this.form);
      })
    }
  },
  methods: {
    onSubmit () {
      ax.save(this.$route.params.seq || null, this.form, (code, msg) => {
        this.$notify({
          group: 'alert',
          type: 'info',
          title: '정보',
          text: msg
        })
        if (code === 200) {
          this.$router.push({ path: '/car', query: this.$route.query })
        }
      })
    },
    resetForm () {
      this.form = _.cloneDeep(this.form_)
      requestAnimationFrame(() => {
        this.$refs.observer.reset()
      })
    },
    cancel () {
      this.$router.push({ path: '/car', query: this.$route.query })
    },
    fuelChanged (v) {
      this.form.fuel = v
    },
    insChanged (v) {
      this.form.ins = v
    },
    insSdateChanged (v) {
      this.form.ins_sdate = v
    },
    insEdateChanged (v) {
      this.form.ins_edate = v
    },
    brandChanged (v) {
      this.form.brand = v
    },
    modelChanged (v) {
      this.form.model = v
    },
    mCompanyChanged (v) {
      // console.log('dataChanged1', v)
      if (v.value !== '') {
        sCompanys(v.text, response => {
          this.companyOption2 = [{ value: '', text: '선택' }, ...response]
        })
      } else {
        this.companyOption2 = [{ value: '', text: '선택' }]
      }
    },
    sCompanyChanged (v) {
      this.form.csseq = v
    }
  }
}
</script>

<style lang="scss" scoped>

.sub_content {
}


</style>
